"use client";

import React from "react";
interface BottomBgProps {
  ref?: React.RefObject<HTMLDivElement | null>;
  isVisible?: boolean;
}
export default function BottomBg({
  ref,
  isVisible = true
}: BottomBgProps) {
  // 四個核心功能的圖示資料集（已依最新文字規範更新）
  const features = [{
    title: "耐磨耐用",
    imgUrl: "https://hent.services/wp-content/uploads/2026/05/Dicovery_Scratch-_Resistant.webp"
  }, {
    title: "生活防水",
    imgUrl: "https://hent.services/wp-content/uploads/2026/05/Dicovery_Prevent_Water.webp"
  }, {
    title: "降噪舒適",
    imgUrl: "https://hent.services/wp-content/uploads/2026/05/Dicovery_No_Noise.webp"
  }, {
    title: "易於清潔",
    imgUrl: "https://hent.services/wp-content/uploads/2026/05/Dicovery_Easy_Clean.webp"
  }];
  return <section id="bottombg" className="w-full overflow-hidden">
      <div ref={ref} className={`relative w-full h-[380px] sm:h-[440px] md:h-[480px] lg:h-[520px] overflow-hidden border-none transition-all duration-[1200ms] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        
        {/* 背景圖片層 */}
        <div className="absolute inset-0 z-0">
          <img src="https://hent.services/wp-content/uploads/2026/05/Dicovery_BG_bottom-scaled.webp" alt="Hent's Premium Flooring Features" className="block h-full w-full object-cover object-center border-none" loading="lazy" decoding="async" />
        </div>

        {/* 內容疊加層：物理垂直置中 */}
        <div className="absolute inset-0 z-10 flex items-center justify-center select-none">
          <div className="container mx-auto px-6 flex flex-col items-center justify-center space-y-10 md:space-y-12">
            
            {/* 主標題：字色 #56493f，字型指定為 Noto Sans HK (Medium) -> 對應 font-medium */}
            <h2 className="font-sans text-2xl sm:text-3xl md:text-4xl font-medium text-[#56493f] tracking-widest leading-tight">
              日子會過，舒服也很重要
            </h2>
            
            {/* 四個核心功能圓框排版區 */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 sm:gap-12 md:gap-16 lg:gap-20 items-center justify-center">
              {features.map((item, index) => <div key={index} className="flex flex-col items-center justify-center space-y-3 group">
                  {/* 圖示外圈：可透過斜線後方的數字自由微調透明度 */}
                  <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-[#2e2927]/15 backdrop-blur-[6px] border border-white/10 shadow-[0_4px_16px_rgba(0,0,0,0.08)] flex items-center justify-center transition-transform duration-500 group-hover:scale-105">
                    <img src={item.imgUrl} alt={item.title} className="w-8 h-8 sm:w-10 sm:h-10 object-contain" />
                  </div>
                  
                  {/* 功能標題：字色 #56493f，字型指定為 Noto Sans HK (Regular) -> 對應 font-normal */}
                  <span className="font-sans text-sm sm:text-base font-normal text-[#56493f] tracking-widest">
                    {item.title}
                  </span>
                </div>)}
            </div>

          </div>
        </div>

      </div>
    </section>;
}